<div class="history-wrapper">
  <div class="history-card" *ngFor="let card of [].constructor(count)">
    <div class="time"></div>
    <div class="avatar"></div>
    <div class="history-action"></div>
  </div>
</div>
